module.exports = __webpack_public_path__ + "static/medio-414e0b4cb7c08eb3a32d62581278a9f4.jpg";